import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import useStyles from './styles'

const TabItem = ({ tabItem, isActive, onClick }) => {
  const classes = useStyles(isActive)

  const { t } = useTranslation()

  return (
    <div className={classes.tabItem} onClick={onClick}>
      {t(tabItem.label)}
    </div>
  )
}

TabItem.propTypes = {
  tabItem: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func
}

export default TabItem
